module.exports = __webpack_public_path__ + "assets/disabled-1671ca.svg";